


































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { PublishedApp } from '../shared/models';
import { config } from '@/config/config';
import { twitterApi } from './services/twitterApi';
import { InstallTwitterRequest, TwitterInstalledApp, TwitterRequestTokenResponse } from './models';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import Toast from '@/shared/services/toast';

@Component({
})
export default class TwitterConfig extends Vue {
	@Getter public currentApp!: PublishedApp;
	@Getter public currentWorkspace!: WorkspaceViewModel;

	public twitterApp: TwitterInstalledApp | null = null;

	public popup: Window | null;
	public requestToken: TwitterRequestTokenResponse | null;
	public oauthToken: string;
	public oauthVerifier: string;

	public connected: boolean = false;

	public loginInProgress: boolean = false;
	public actionInProgress: boolean = false;

	public created() {
		(window as any)['twitter-setup-ref'] = { component: this };

		window.onbeforeunload = () => {
			if (this.popup) {
				this.popup.close();
			}
		};

		if (this.currentApp.isInstalled) {
			twitterApi.getInstalledApp(this.currentWorkspace.id)
				.then(twitterApp => {
					this.twitterApp = twitterApp;
				}).catch(err => {
					// if it's not found, then we haven't installed the bt app fully, so let them fill in the form
					if (err.status !== 404) {
						// show error state...
					}
				}).finally(() => {
					this.$emit('loaded');
				});
		} else {
			this.$emit('loaded');
		}
	}

	public destroyed() {
		if (this.popup) {
			this.popup.close();
		}
		window.onbeforeunload = null;
	}

	public hasTwitterInstalledApp() {
		return this.twitterApp !== null;
	}

	public login() {
		this.loginInProgress = true;
		if (!this.connected) {
			const props =
				`scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=600,height=420,left=100,top=100`;
			this.popup = window.open(`${location.origin}/twitter-auth?fc=true`, 'Twitter Authentication', props);
			twitterApi.getRequestToken()
				.then((res) => {
					this.requestToken = res;
					if (this.popup) {
						this.popup.location.href = this.requestToken.url;
					}
				})
				.catch((err) => {
					Toast.showError(err.message);
					if (this.popup) {
						this.popup.close();
					}
					this.loginInProgress = false;
				});
		}
	}

	public setAuthToken(oauthToken: string, oauthVerifier: string) {
		if (this.requestToken && this.requestToken.token === oauthToken) {
			this.oauthToken = oauthToken;
			this.oauthVerifier = oauthVerifier;
			this.connected = true;
			this.loginInProgress = false;
		}
	}

	public reset() {
		this.oauthToken = '';
		this.oauthVerifier = '';
		this.requestToken = null;
		this.connected = false;
		this.loginInProgress = false;
	}

	public save() {
		if (this.actionInProgress) {
			return;
		}

		this.actionInProgress = true;

		const request = {
			installId: this.currentApp.installedAppId,
			workspaceId: this.currentWorkspace.id,
			token: this.oauthToken,
			verifier: this.oauthVerifier,
			secret: (this.requestToken) ? this.requestToken.secret : ''
		} as InstallTwitterRequest;

		twitterApi.install(request)
			.then(() => this.$emit('configSaved'))
			.catch((err) => {
				Toast.showError(err.message);
				this.reset();
			})
			.finally(() => this.actionInProgress = false);
	}

	public cancel() {
		this.$router.push({ name: 'apps' });
	}

}
